module.exports = __webpack_public_path__ + "static/media/gasolineIcon.524c1ce4.svg";